import { ResponseValue } from "../../store/reducers/tableManagementReducer";

export function mapThunkTypeToResponseValue(type: string): ResponseValue {
  if (type.endsWith("/fulfilled")) return "fulfilled";
  if (type.endsWith("/rejected")) return "rejected";
  return "pending";
}